import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.div`
  ${({ theme }) => css`
    margin-right: 8px;

    svg {
      fill: ${theme?.colour?.primary};
      width: 13px;
      height: 13px;
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'object', template })